import React from "react";
import { Quote } from "lucide-react";

const Mission = () => (
  <section id="philosophy" className="py-16 sm:py-24 relative overflow-hidden" data-testid="mission-section">
    <div className="absolute inset-0 bg-light-blue" />
    <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-brand-yellow/25 blur-3xl" />
    <div className="absolute inset-0 dotted-pattern opacity-30" />

    <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Our philosophy</span>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold mt-3 mb-10 leading-tight">
        Discovering every child's
        <span className="text-brand-blue"> innate qualities </span>
      </h2>

      <div className="bg-white rounded-[2.5rem] p-8 sm:p-12 shadow-[0_30px_60px_rgba(30,91,184,0.10)] relative">
        <Quote className="absolute -top-6 left-8 w-12 h-12 text-brand-yellow bg-white p-2 rounded-full shadow-md" />
        <p className="text-base sm:text-lg text-[color:var(--text-primary)] leading-relaxed font-medium">
          <span className="font-heading text-brand-blue font-bold">Innovative Preschool</span> was
          established in the year <strong>2017 (2073 BS)</strong> with the main objective of
          creating a preschool education environment where children can discover their innate
          qualities. Innate qualities are the unique set of internal talents or strengths every
          child possesses, which remain unchanged from birth.
        </p>
        <p className="mt-5 text-base sm:text-lg text-[color:var(--text-secondary)] leading-relaxed">
          Every child has an equal amount of <em>conative</em> for engaging with the{" "}
          <strong className="text-brand-blue">cognitive (thinking)</strong> and{" "}
          <strong className="text-brand-blue">affective (feeling)</strong> parts of the mind to
          produce purposeful action.
        </p>
        <p className="mt-5 text-base sm:text-lg text-[color:var(--text-secondary)] leading-relaxed">
          Innovative Preschool provides more than just education; we{" "}
          <span className="px-1 bg-brand-yellow/40 rounded">inculcate, nurture, educate</span> and
          expand children's thinking and language — while supporting their physical,
          socio-emotional development and creativity.
        </p>
      </div>

      <div className="mt-10 grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
        {[
          { t: "Cognitive", d: "Thinking, language and curiosity" },
          { t: "Affective", d: "Feeling, empathy and self-awareness" },
          { t: "Conative", d: "Purposeful action and creativity" },
        ].map((b, i) => (
          <div key={i} className="bg-white/80 rounded-2xl p-5 backdrop-blur" data-testid={`philosophy-block-${i}`}>
            <div className="font-heading font-bold text-brand-blue text-lg">{b.t}</div>
            <div className="text-sm text-[color:var(--text-secondary)] mt-1">{b.d}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Mission;
